import React from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/ui/Header';
import Icon from '../../components/AppIcon';
import Button from '../../components/ui/Button';

const UroPayCancelPage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-lg px-4 py-10">
        <div className="bg-card rounded-xl shadow-warm-lg p-6 md:p-8 text-center">
          <Icon name="XCircle" size={56} className="mx-auto mb-3 text-warning" />
          <h1 className="text-2xl font-heading font-bold mb-2">Payment Not Completed</h1>
          <p className="text-muted-foreground mb-6">
            You can try again anytime from the subscription page.
          </p>
          <Button onClick={() => navigate('/subscription-payment')} fullWidth>
            Back to Subscription
          </Button>
        </div>
      </main>
    </div>
  );
};

export default UroPayCancelPage;
